import { useMutation,useQuery } from '@tanstack/vue-query'
import { AcademicYear } from '@/api/Dara/Organisations'
import { oneHourInMS } from '@/composable/useDatesAndTimes'
import { academicYearsKeys, organisationKeys } from '@/composable/queries/keys'

export const useAcademicYearStatsQuery = (
  academicYearId: Ref<number>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: academicYearsKeys.stats(academicYearId),
    queryFn: () => AcademicYear.getAcademicYearStats(academicYearId.value),
    staleTime: oneHourInMS,
    enabled,
  })

export const useAcademicYearProgrammeStatsQuery = (
  academicYearId: Ref<number>,
  programmeId: Ref<number>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: academicYearsKeys.programmeStats(academicYearId, programmeId),
    queryFn: () => AcademicYear.getAcademicYearProgrammeStats(academicYearId.value, programmeId.value),
    staleTime: oneHourInMS,
    enabled,
  })

export const useOrganisationAcademicYearQuery = (
  organisationId: Ref<number>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: organisationKeys.academicYears(organisationId),
    queryFn: () => AcademicYear.getAcademicYearList(organisationId.value),
    staleTime: oneHourInMS,
    enabled,
  })

export const useUpdateAcademicYearAcknowledgement = (
  academicYearId: Ref<number>,
) => {
  return useMutation({
    mutationFn: () => AcademicYear.updateAcademicYearAcknowledgement(academicYearId.value),
  })
}
